import { render, staticRenderFns } from "./caret-down.vue?vue&type=template&id=b52875c2&"
import script from "./caret-down.vue?vue&type=script&lang=js&"
export * from "./caret-down.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports